


export default function CashRegister(){
    
}